import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureShowcase from './components/FeatureShowcase';
import ContentHub from './components/ContentHub';
import ArticleCards from './components/ArticleCards';
import TestimonialSection from './components/TestimonialSection';
import CTABanner from './components/CTABanner';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://superbuyspread.bond';

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Superbuy Spreadsheet",
  "url": siteUrl,
  "description": "Smart shopping sheets to find products fast across 14 curated categories — Shoes, Hoodies, T-Shirts, Jackets, Accessories and more.",
  "sameAs": ["https://kaspreadsheet.com"]
};

const breadcrumbJsonLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Superbuy Spreadsheet",
      "item": siteUrl
    }
  ]
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureShowcase />
        <ContentHub />
        <ArticleCards />
        <TestimonialSection />
        <CTABanner />
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}></script>
    </>
  );
}